



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'IntegrationMoreInfoModal',
})
export default class IntegrationMoreInfoModal extends Vue {
    @Prop({
        required: false,
        default: '',
    })
    public title: string;

    private isFullscreen = false;
}
